import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { RotatingLines } from 'react-loader-spinner';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, BrowserRouter as Router, Route, Link, useParams } from "react-router-dom";
function StaffReportView() {
    const [loading, setLoading] = useState(true);
    const [stbCount, setStbCount] = useState(true);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [error, setError] = useState(null);
    const [rowsData, setRowsData] = useState([]);
    const [staffCustomer, setStaffCustomer] = useState([]);
    const [wallet, setWalletAmount] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: "name", direction: "ascending" });
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage] = useState(100);
    const user = getCookie('user');
    const [searchQuery, setSearchQuery] = useState("");
    const [formData, setFormData] = useState({ date: "", toDate: "" })
    const initialFormData = { date: "", toDate: "" }
    function getCookie(name) {
        const cookies = document.cookie.split('; ');
        for (const cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === name) { return value; }
        } return null;
    }
    if (!user) { navigate('/'); }
    function handleChange(e) {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const downloadCSV = () => {
        const headers = ["Sno", "Customer__Name", "Acc_no", "Code", "STB_no", "D_no", "Flat_name", "Street__name", "Phone", "Pay Status", "Plan Amount", "Paid Amount", "Paid_Date", "Balance Amount", "Discount Amount", "Advance Amount", "Pending Amount", "Staff__Code", "Network", "Paid_time", "Package", "Added_date", "Collection Staff"];
        const csvRows = [];
        csvRows.push(headers.join(","));
        staffCustomer.forEach(row => { csvRows.push([row.id, row.name, row.account_num, row.acc_num, row.serial_num, row.doorno, row.flat_name, row.street, row.mobile, row.status, row.pay_amt, row.paid_amt, row.paid_date, row.balance, row.discount, row.extra_Balance_amt, row.pend_amt, row.area_code, row.net_name, row.paid_time, row.package, row.adate, row.col_boy].join(",")); });
        const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "CableTvPay.csv");
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };
   // 1. FILTER FIRST
const filteredRows = staffCustomer.filter((row) =>
  Object.values(row).some(value =>
    String(value).toLowerCase().includes(searchQuery.toLowerCase())
  )
);

const totalPaidAmt = filteredRows.reduce((s, r) => s + Number(r.paid_amt || 0), 0);


// 3. PAGINATE FILTERED DATA ONLY
const indexOfLastRow = currentPage * rowsPerPage;
const indexOfFirstRow = indexOfLastRow - rowsPerPage;
const currentRows = filteredRows.slice(indexOfFirstRow, indexOfLastRow);

// 4. TOTAL PAGES FOR FILTERED DATA
const totalPages = Math.ceil(filteredRows.length / rowsPerPage);

// 5. Pagination function
const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const handleClear = () => { setFormData(initialFormData); };
    const { area_code } = useParams();
 
    function handleSubmit(e) {
        setIsButtonDisabled(true);
        e.preventDefault();
        console.log("Form Data:", formData); a();
        async function a() {
            try {
                const response = await axios.post('https://node.cabletvpay.in/StaffCustomerSpecific', { user, formData,area_code });
                if (response.status === 200) {
                    console.log(response.data.results);
                      setStbCount(response.data.results.length);
                        setStaffCustomer(response.data.results);                                     
                    setIsButtonDisabled(false);
                }
            } catch (err) {
                toast.error(err.response?.data?.message || "Error fetching data");
                setIsButtonDisabled(false)
            }
        }
    }
    
        const fetchUserData = async () => {
        if (!area_code) {
            console.error("❌ Missing area_code before API call.");
            return;
        }
    
        try {
            const response = await axios.post('https://node.cabletvpay.in/staffReportView', { user, area_code });
            if (response.status === 200) {
                setStbCount(response.data.staffCustomer.length);
                setStaffCustomer(response.data.staffCustomer);
            }
        } catch (err) {
            setError(err.response?.data?.message || "Error fetching data");
            console.log(err);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchUserData();
    }, []);
    const stb = useMemo(() => staffCustomer.map(row => parseInt(row.serial_num, 10)), [staffCustomer]);
    const handleCopyToClipboard = () => { navigator.clipboard.writeText(stb).then(() => { toast.info(`${stbCount} STB numbers copied`); }).catch((error) => { toast.warning("not copied: " + error); }); };
   
    if (loading) return (<div className="content-wrapper">
        <div className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
            <RotatingLines visible={true} height="80" width="80" strokeColor="#007bff" strokeWidth="2" animationDuration="0.75" ariaLabel="rotating-lines-loading" wrapperStyle={{}} wrapperClass="" />
        </div></div>)
    if (error) return (<div className="content-wrapper">
        <div className="d-flex justify-content-center align-items-center" style={{ height: "73vh" }}>
            <img src="../asset/img/errorPage.jpg" alt="" style={{ height: "20rem" }} />
        </div></div>);
    return (
        <div className="content-wrapper">
            <div className="content-header pt-1">
                <h5 className='h5'>STAFF REPORT DETAILS</h5><hr className='mt-0' />
                <div style={{ position: 'absolute', top: '30px' }}><ToastContainer theme='dark' /></div>
              <div className="border-0 px-1">
              <div className="row mx-3 d-flex justify-content-center">
    <div className="col-lg-6 col-md-6 col-12 mb-2">
        <h2 className="text-navy">
          <span className="text-bold text-orange">
    {staffCustomer?.[0]?.col_boy ?? "N/A"}
</span>
 Report Details
        </h2>
    </div>
    <div className="col-lg-6 col-md-6 col-12 mb-2">
        <h2 className="text-navy">
            Total Paid Amount: <span className="text-bold text-orange">{totalPaidAmt || "0"}</span>
        </h2>
    </div>
</div>

</div>
           <hr />
                <div className="mt-3 mb-2 mb-lg-5 mx-lg-5">
                    <div className="border-0 px-1">

                    <form method="get" onSubmit={handleSubmit}>
                            <div className="row mx-3 d-flex justify-content-center">
                              
                                <div className="col-lg-3 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="date" className="text-center valuesDec text-navy">From</label>
                                        <input type="date" className="form-control text-white bg-gradient-navy border-0 elevation-3" name="date" id="date" value={formData.date} onChange={handleChange} />
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="toDate" className="text-center valuesDec text-navy">To</label>
                                        <input type="date" className="form-control text-light bg-gradient-navy border-0 text-white elevation-3" name="toDate" id="toDate" value={formData.toDate} onChange={handleChange} />
                                    </div>
                                </div>
                                <div className="col-lg-1 col-md-3 col-6 py-4 pt-1 d-flex justify-content-center">
                                    <input type="submit" className="btn border-0  bg-info filterBtn text-light pb-3 pb-lg-1 w-100" disabled={isButtonDisabled} value="Filter" />
                                </div>
                                <div className="col-lg-1 col-md-3 col-6  py-4 pt-1 d-flex justify-content-center">
                                    <button type="button" className="btn border-0 bg-danger filterBtn text-light  pb-3 pb-lg-1 w-100" onClick={handleClear} > Clear </button>
                                </div>

                            </div>

                        </form>
                    </div>
                </div>

                <div className="card elevation-5 mt-3 mt-lg-5" style={{ backgroundColor: "#cccccc" }}>
                    <div className="card-header filterBtn">
                        <div className="row">
              
                            <div className="col-lg-8 mt-1">
                                <span><div className="row w-auto">
                                    <div className="col-11 col-lg-6">
                                        <div className="input-group">
                                            <input type="text" className="form-control text-navy bg-light border-0 px-1 py-0" placeholder="Search..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} style={{ borderRadius: "5px 0 0 5px" }} />
                                            <span className="input-group-text bg-light text-navy border-0 px-2" id="basic-addon1" style={{ borderRadius: "0 5px 5px 0" }} > <i className="fas fa-search" /> </span>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 mt-1 mt-lg-0">
                                        <div className="d-flex justify-content-end">
                                            <div className=" btn-group">
                                                <button onClick={downloadCSV} className="btn btn-dark border-right px-lg-3 px-5 my-1 d-flex"><i className="fas fa-download pt-1 px-1" /> Download</button>
                                                 <button type="button" className="btn btn-dark border-left px-lg-3 px-5 my-1 d-flex" data-toggle="modal" onClick={handleCopyToClipboard} data-target="#exampleModal"> <i className="far fa-copy pt-1 px-1" /> STBCOPY-{stbCount} </button>
                                            </div>
                                        </div>
                                    </div>
                                </div></span>
                            </div>
                        </div>
                    </div>
                    <div className="card-body p-0">
                                  <table
  id="myTable"
  className="table table-bordered table-dark table-responsive"
>                            <thead className="bg-gradient-navy">
                                <tr>
                                    <th>Sl_No</th>

                                    <th>Customer__Name</th>
                                    <th>Acc_no</th>
                                    <th>Code</th>
                                    <th>STB_no</th>
                                    <th>Networks</th>
                                   
                                    <th>Phone</th>
                                    <th>Staff__Code</th>
                                    <th>Pay Status</th>
                                    <th>Plan Amount</th>
                                    <th>Paid Amount</th>
                                    <th>Paid__Date</th>
                                    <th>Paid_Time</th>
                                    <th>Balance Amount</th>
                                    <th>Discount Amount</th>
                                    <th>Advance Amount</th>
                                    <th>Pending Amount</th>

                                    <th>Collection_Staff</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentRows.length > 0 ? (currentRows.map((row, index) => (
                                    <tr key={index} className='text-dark' style={{ backgroundColor: row.status === "unpaid" ? "#ffd9de" : "#cffcd0" }}>
                                        <td className='tableText'>{indexOfFirstRow + index + 1}</td>
                                        <td className='tableText border-light'>{row.name}</td>
                                        <td className='tableText border-light'>{row.account_num}</td>
                                        <td className='tableText border-light'>{row.acc_num}</td>
                                        <td className='tableText border-light'>{row.serial_num}</td>
                                        <td className='tableText border-light'>{row.net_name}</td>
                                      
                                        <td className='tableText border-light'>{row.mobile}</td>
                                        <td className='tableText border-light'>{row.area_code}</td>
                                        <td className='tableText border-light'>{row.status}</td>
                                        <td className='tableText border-light'>{row.pay_amt}</td>
                                        <td className='tableText border-light'>{row.paid_amt}</td>
                                        <td className='tableText border-light'>{row.paid_date}</td>
                                        <td className='tableText border-light'>{row.paid_time}</td>
                                        <td className='tableText border-light'>{row.balance_amt}</td>
                                        <td className='tableText border-light'>{row.discount}</td>
                                        <td className='tableText border-light'>{row.extra_balance_amt}</td>
                                        <td className='tableText border-light'>{row.pend_amt}</td>


                                        <td className='tableText border-light'>{row.col_boy}</td>
                                    </tr>
                                ))) : (<tr><td colSpan="10">No results found</td></tr>)}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="d-flex justify-content-end">
                    <div className="pagination btn-group">
                        <button className="btn bg-navy border-right" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} style={{ opacity: currentPage === 1 ? 0.6 : 1 }} ><i className="fas fa-backward"></i></button>
                        <button onClick={() => paginate(1)} className={`btn ${currentPage === 1 ? "bg-navy" : "btn-outline-secondary"} border-left`} > 1 </button>
                        {currentPage > 3 && <span className="mx-1">...</span>}
                        {Array.from({ length: 3 }, (_, i) => currentPage - 1 + i).filter((page) => page > 1 && page < totalPages).map((page) => (<button key={page} onClick={() => paginate(page)} className={`btn ${currentPage === page ? "bg-navy" : "btn-outline-secondary"}`} style={{ fontWeight: currentPage === page ? "bold" : "normal" }} > {page} </button>))}
                        {currentPage < totalPages - 2 && <span className="mx-1">...</span>}
                        {totalPages > 1 && (<button onClick={() => paginate(totalPages)} className={`btn ${currentPage === totalPages ? "bg-navy" : "btn-outline-secondary"} border-right`}>{totalPages}</button>)}
                        <button className="btn bg-navy  border-left" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} style={{ opacity: currentPage === totalPages ? 0.6 : 1 }} ><i className="fas fa-forward"></i></button>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default StaffReportView;
